let audioContext: AudioContext | null = null;

function getAudioContext() {
  if (typeof window === "undefined") return null;
  const AudioContextCtor = window.AudioContext || (window as Window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!AudioContextCtor) return null;
  audioContext ||= new AudioContextCtor();
  return audioContext;
}

function tone(frequency: number, start: number, duration: number, volume: number) {
  const context = getAudioContext();
  if (!context) return;
  if (context.state === "suspended") void context.resume();
  const oscillator = context.createOscillator();
  const gain = context.createGain();
  oscillator.type = "sine";
  oscillator.frequency.value = frequency;
  gain.gain.setValueAtTime(0.0001, start);
  gain.gain.exponentialRampToValueAtTime(volume, start + 0.012);
  gain.gain.exponentialRampToValueAtTime(0.0001, start + duration);
  oscillator.connect(gain).connect(context.destination);
  oscillator.start(start);
  oscillator.stop(start + duration + 0.02);
}

export function playTypingCue() {
  const context = getAudioContext();
  if (!context) return;
  const start = context.currentTime + 0.01;
  [660, 740, 880, 660].forEach((frequency, index) => tone(frequency, start + index * 0.105, 0.045, 0.018));
}

export function playMessageSentCue() {
  const context = getAudioContext();
  if (!context) return;
  tone(520, context.currentTime + 0.01, 0.055, 0.016);
}
